import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { Popover, MenuItem, Menu, Position, Icon } from "@blueprintjs/core";
import { setLocale } from "react-redux-i18n";

const languages = {
  en: { icon: "english", label: "English", short_label: "En" },
  sv: { icon: "swedish", label: "Sverige", short_label: "Sv" },
  de: { icon: "german", label: "German", short_label: "De" }
};

export default function LanguageSelector() {
  const dispatch = useDispatch();
  const selectedLanguage = useSelector(state => state.i18n.locale);
  const onLangClick = (language) => {
    dispatch(setLocale(language));
  }

  const languageMenu = (
    <Menu className="language-switcher-menu">
      <MenuItem
        className="item-en"
        onClick={() => onLangClick("en")}
        text="English"
      />
      <MenuItem
        className="item-sv"
        onClick={() => onLangClick("sv")}
        text="Sverige"
      />
      <MenuItem
        className="item-sv"
        onClick={() => onLangClick("de")}
        text="German"
      />
    </Menu>
  );
  return (
    <Popover content={languageMenu} position={Position.BOTTOM_RIGHT}>
      <div className="language-switcher">
        <span className="lang-name">
          <span className={`flag-icon ${languages[selectedLanguage].icon}`} />
          {languages[selectedLanguage].short_label}
        </span>
        <Icon icon="chevron-down" className="icon" />
      </div>
    </Popover>
  );
}
